import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";

import useModal from "../dialog/useModal";
import { Warning } from "../svg/svgImageList";
import { PubSubEvents } from "../../services/PubSubEvents";
import { Notification } from "../../services/notifications/NotificationsService";
import { lastAccessedOrganizationService } from "../../services/organization/LastAccessedOrganizationStorage";
import { currentUserService } from "../../services/user/CurrentUserStorage";
import useThemeService from "../../services/theme-service/ThemeService";
import { Dialog } from "../dialog/Dialog";

export default observer(function OrganizationCollaborationStoppedNotification() {
  const { themeClass } = useThemeService();
  const { toggleModal, isVisible } = useModal();

  useEffect(() => {
    var subscribeToken = PubSub.subscribe(
      PubSubEvents.OrganizationCollaborationStopped,
      (event: string, notification: Notification) => {
        if (lastAccessedOrganizationService.data.organizationId === notification.organizationId) {
          toggleModal();
        } else {
          currentUserService.load();
        }
      }
    );

    return function cleanup() {
      PubSub.unsubscribe(subscribeToken);
    };
  }, [toggleModal]);

  const iconWarning = {
    svg: Warning,
    width: 30,
    height: 30,
    className: themeClass(["icon-warning"], ["partially-failed"]),
  };

  const handleCloseAction = () => {
    toggleModal();
    window.location.href = "/";
  };

  return (
    <Dialog
      isVisible={isVisible}
      iconTitle={iconWarning}
      titleKey="general.OrganizationCollaborationStoppedModal.title"
      subTextKey="general.OrganizationCollaborationStoppedModal"
      onHide={handleCloseAction}
      buttonOk={{
        id: "collaboration-stopped-ok",
        textKey: "general.ok",
        action: handleCloseAction,
      }}
    ></Dialog>
  );
});
